<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">payments</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Lançamentos do financeiro</h2>
        <span class="modal-subtitle">{{ data.rotuloDocumento }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content scroll-suave">
    @if (isLoading) {
        <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
    } @else if (!temFinanceiro) {
        <p class="descricao-modal">O Finanças não tem financeiro ativo deste pedido.</p>
    } @else {
        <p class="descricao-modal">
            Títulos e movimentações que o pedido gerou no Finanças. Eles só são alterados ou excluídos pelo pedido;
            recebimento, cobrança, tags e categoria seguem pelo Finanças.
        </p>
        <app-pv-financeiro-lancamentos [contas]="contas" [movimentacoes]="movimentacoes"></app-pv-financeiro-lancamentos>
    }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-flat-button type="button" class="btn-primary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
